module.exports = __webpack_public_path__ + "static/media/ppic.a94d868d.jpg";